module.exports = __webpack_public_path__ + "static/media/scr_launch_android.4210e40d.png";